$(document).ready(function(){
   $('.cstm_product_slider').slick({
    dots: false,
    arrow: true,
    prevArrow: '<button type="button" class="slick-prev slick-arrow" style=""><svg viewBox="0 0 100 100"><path d="M 20,50 L 60,90 L 60,85 L 25,50  L 60,15 L 60,10 Z" class="arrow"></path></svg></button>', 
    nextArrow: '<button type="button" class="slick-next slick-arrow" style=""><svg viewBox="0 0 100 100"><path d="M 20,50 L 60,90 L 60,85 L 25,50  L 60,15 L 60,10 Z" class="arrow" transform="translate(100, 100) rotate(180) "></path></svg></button>',
    slidesToShow: 4,
    slidesToScroll: 1,
    swipe: false,
      touchMove: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 750,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          centerMode: true,
          centerPadding: '120px',
        }
      }
    ]
  });

 if($(window).width()>749){
  /*Desktop Thumbnails*/ 
$('.product--no_cstm .thumbnail-list').slick({
    dots: false,
    arrow: true,
    vertical: true,
    nextArrow: '<button type="button" class="slick-next"><svg viewBox="0 0 100 100"><path d="M 20,50 L 60,90 L 60,85 L 25,50  L 60,15 L 60,10 Z" class="arrow" transform="translate(100, 100) rotate(180) "></path></svg></button>', 
    prevArrow: '<button type="button" class="slick-prev"><svg viewBox="0 0 100 100"><path d="M 20,50 L 60,90 L 60,85 L 25,50  L 60,15 L 60,10 Z" class="arrow"></path></svg></button>',
    slidesToShow: 5,
    slidesToScroll: 1,
    focusOnSelect: true,
   infinite:true,
  watchCss:true,
    asNavFor: '.product--no_cstm .product__media-list',
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
        }
      }
    ]
  });
  $('.product--no_cstm .product__media-list').slick({
    dots: false,
    arrow: true,
    nextArrow: '<button type="button" class="slick-next"><svg viewBox="0 0 100 100"><path d="M 20,50 L 60,90 L 60,85 L 25,50  L 60,15 L 60,10 Z" class="arrow" transform="translate(100, 100) rotate(180) "></path></svg></button>', 
    prevArrow: '<button type="button" class="slick-prev"><svg viewBox="0 0 100 100"><path d="M 20,50 L 60,90 L 60,85 L 25,50  L 60,15 L 60,10 Z" class="arrow"></path></svg></button>',
    slidesToShow: 1,
    slidesToScroll: 1,
     focusOnSelect: true,
     asNavFor: '.product--no_cstm .thumbnail-list'
  });
  
  /*End Desktop Thumbnails*/ 
  }

$(".size_name").click(function(){
if(!$(this).hasClass('active')){
if($(this).hasClass('in_size_table')){
  $('.size-changetd').each(function(){
    var innerTxt = parseFloat($(this).text().trim());
    var multiVal = innerTxt/2.54;
    $(this).text(parseFloat(multiVal).toFixed(1));
  })
}else{
   console.log('sssss');
  $('.size-changetd').each(function(){
    var innerTxt = parseFloat($(this).text().trim());
    var multiVal = 2.54*innerTxt;
    $(this).text(parseFloat(multiVal).toFixed(1));
  })
}
  $(".size_name").removeClass('active');
$(this).addClass('active');
}
});
  
});

// ============================legal report================================
 $(document).ready(function(){
    $('.accord-head').click(function(){
      $(this).parent().find('.accord-body').toggleClass('showReport');
      $('.accord-head').not(this).parent().find('.accord-body').removeClass('showReport');
      $(this).toggleClass('clicked');
      $('.accord-head').not(this).removeClass('clicked');
    });

 // open a specific page when clicking on a navigation menu item    
    $('.accord-head.first').click(function(event){
        // Prevent the default behavior of the link
        event.preventDefault();
        // Navigate to the desired page
        window.location.href = '/pages/report-overview';
    });    
  });
// ============================legal report================================



    document.addEventListener('DOMContentLoaded', () => {
  if (window.innerWidth < 750) {
    document
      .querySelectorAll('.product__media-list.slider--mobile')
      .forEach(el => {
        el.classList.remove('slider', 'slider--mobile');
      });
  }
});

$(document).ready(function () {

  if ($(window).width() < 750) {

    const $gallery = $('.product__media-list');

    if ($gallery.length && !$gallery.hasClass('slick-initialized')) {
      $gallery.slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true, 
        arrows: true,
        nextArrow:
        '<button type="button" class="slick-next"><svg viewBox="0 0 100 100"><path d="M 20,50 L 60,90 L 60,85 L 25,50  L 60,15 L 60,10 Z" class="arrow" transform="translate(100, 100) rotate(180) "></path></svg></button>',
      prevArrow:
        '<button type="button" class="slick-prev"><svg viewBox="0 0 100 100"><path d="M 20,50 L 60,90 L 60,85 L 25,50  L 60,15 L 60,10 Z" class="arrow"></path></svg></button>',
      });
    }
  }

});
